import { Image, t } from '@slot-nx/core'
import { Container, Text } from '@pixi/react'
import { TextStyle } from 'pixi.js'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

const voucherTimeContentTextStyle = new TextStyle({
  align: 'center',
  fontWeight: '900',
  fill: '#FFD943',
  fontFamily: 'Roboto',
  fontSize: 43,

})

dayjs.extend(utc)
dayjs.extend(timezone)

function formatDateTimeAuto(dateTime: Date) {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const d = dayjs.utc(dateTime).tz(userTimezone)
  const datePart = d.format('YYYY-MM-DD')
  const timePart = d.format('HH:mm')
  return { date: datePart, time: timePart }
}

export const VoucherSelectPopupTime = (props: { expireTime: Date }) => {
  const { date, time } = formatDateTimeAuto(props.expireTime)

  return (
    <Container name="VoucherTimeContent">
      <Text
        text={t('voucher_select_popup_expire_time_title')}
        x={0}
        y={280}
        anchor={[0.5, 0.5]}
        name="VoucherTimeContent"
        style={voucherTimeContentTextStyle}
      />
      <Image
        name="voucher_time"
        image="voucher_Time_left"
        width={423}
        height={56}
        anchor={[0.5, 0.5]}
        x={0}
        y={350}
      />

      <Text
        text={date}
        x={-40}
        y={350}
        anchor={[0.5, 0.5]}
        name="VoucherTimeContent"
        style={new TextStyle({
          align: 'center',
          fontWeight: '600',
          fill: '#FFFFFF',
          fontFamily: 'Roboto',
          fontSize: 33,

        })}
      />
      <Text
        text={time}
        x={130}
        y={350}
        anchor={[0.5, 0.5]}
        name="VoucherTimeContent"
        style={new TextStyle({
          align: 'center',
          fontWeight: '600',
          fill: '#FF65DE',
          fontFamily: 'Roboto',
          fontSize: 33,
        })}
      />

    </Container>
  )
}
